<template>
  <div>
    <CardWrapper :has-access="1" :is-loading="preloader" style="height: 100px">
      <template #title>ТАБЛО ПРИЛЕТА</template>
      <template #icon>
        <ArrivalIcon/>
      </template>
      <TableWrapper>
        <v-data-table
          :headers="this.headers"
          :items="this.arrivalBoard"
          :search="search"
          class="elevation-0 small-table maxH"
          rows-per-page-text="Строк на странице"
          hide-actions
        >
          <template slot="items" slot-scope="props">
            <td>
              {{ props.item.FlightNumber }}
            </td>
            <td class="text-xs-left ws-no">
              <v-icon>flight_land</v-icon>
              {{ props.item.DepTime }}
            </td>
            <td class="text-xs-left">{{ props.item.ap_name }}</td>
            <td class="text-xs-left">
              <div v-if="props.item.logo" v-html="imgWrap(props.item.logo, logoSize)"></div>
            </td>
            <td class="text-xs-left">
              <v-chip
                :color="props.item.StatusColor || 'blue-grey lighten-3'"
                small
                text-color="white"
              >{{ (props.item.Status || 'по расписанию').toLowerCase() }}</v-chip>
            </td>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="warning"
          >Поиск по "{{ search }}" не дал результатов.</v-alert>
        </v-data-table>

      </TableWrapper>


    </CardWrapper>
  </div>
</template>

<script>
import store from '@/store'
import CardWrapper from "../ui/CardWrapper.vue";
import ArrivalIcon from "../ui/icons/ArrivalIcon.vue";
import TableWrapper from "../ui/TableWrapper.vue";

let headers = [
  {
    text: '№ Рейса',
    align: 'left',
    sortable: false,
    value: 'FlightNumber',
  },
  {
    text: 'Прибытие',
    sortable: false,
    value: 'DepTime',
  },
  {
    text: 'Направление',
    sortable: false,
    value: 'NameAirport',
  },
  {
    text: 'Авиакомпания',
    sortable: false,
    value: 'Airline',
  },
  {
    text: 'Статус',
    sortable: false,
    value: 'Status',
  },
]

export default {
  components: {TableWrapper, ArrivalIcon, CardWrapper},
  data() {
    return {
      search: '',
      headers: headers,
      logoSize: 20,
    }
  },
  computed: {
    arrivalBoard: {
      get() {
        return store.getters['board/getArrivalBoard']('current')
      },
    },
    preloader: {
      get() {
        return store.getters['board/getArrivalPreloader']
      },
      set(value) {
        store.commit('board/setArrivalPreloaderState', value)
      },
    },
  },
  methods: {
    update: function() {
      store.dispatch('board/updateArrivalBoard')
    },
    imgWrap: function(url, size) {
      return '<img height="' + size + 'px" src="' + url + '"/>'
    },
  },
}
</script>
